import "../styles/Skills.scss";

const Skills = () => {
  return (
    <section id="skills" className="skills">
      <div className="skills-wrapper">
        <h2 className="section-title">Skills</h2>
        <div className="skills-container">
          <div className="skill-category">
            <h3>Libraries &amp; Languages</h3>
            <ul className="skill-list">
              <li>JavaScript (ES6)</li>
              <li>React</li>
              <li>TypeScript</li>
              <li>Node</li>
              <li>HTML5</li>
              <li>CSS3</li>
              <li>Framer Motion</li>
              <li>GSAP</li>
            </ul>
          </div>
          <div className="skill-category">
            <h3>CSS</h3>
            <ul className="skill-list">
              <li>Responsive Design Patterns</li>
              <li>CSS Grid &amp; Flexbox</li>
              <li>SASS/LESS Architecture</li>
              <li>CSS-in-JS Solutions</li>
            </ul>
          </div>
          <div className="skill-category">
            <h3>Performance</h3>
            <ul className="skill-list">
              <li>Core Web Vitals Optimization</li>
              <li>Bundle Size Reduction</li>
              <li>Lazy Loading Strategies</li>
            </ul>
          </div>
          <div className="skill-category">
            <h3>UX/UI Design/Engineering</h3>
            <ul className="skill-list">
              <li>Accessibility (WCAG)</li>
              <li>Design Systems</li>
              <li>Storybook</li>
              <li>Component Libraries</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
